import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChartNavigationContext, PatientListNavigation } from './models/patient-list-navigation.model';

@Injectable({
  providedIn: 'root',
})
export class PatientListNavigationService {
  currentPatientListNavSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  currentPatientListNavObs$: Observable<boolean> = this.currentPatientListNavSubject.asObservable();

  currentPatientListNavClinicalSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  currentPatientListNavClinicalNavObs$: Observable<boolean> = this.currentPatientListNavClinicalSubject.asObservable();

  chartNav$: Observable<ChartNavigationContext | null>;

  private chartNavSubject: BehaviorSubject<ChartNavigationContext | null> =
    new BehaviorSubject<ChartNavigationContext | null>(null);

  constructor() {
    this.chartNav$ = this.chartNavSubject.asObservable();
  }

  public setCurrentPatientListNav(navigation: PatientListNavigation): void {
    this.currentPatientListNavSubject.next(navigation);
  }

  public setCurrentPatientListClinicalNav(navigation: PatientListNavigation): void {
    this.currentPatientListNavClinicalSubject.next(navigation);
  }

  public setChartNavigationContext(context: ChartNavigationContext): void {
    this.chartNavSubject.next(context);
  }

  public updateCurrentIndex(index: number): void {
    const current = this.chartNavSubject.getValue();
    if (current) {
      this.chartNavSubject.next({ ...current, currentIndex: index });
    }
  }

  public clearChartNavigationContext(): void {
    this.chartNavSubject.next(null);
  }
}
